import React, { useEffect, useState } from 'react';
import './Path.scss';
import { connect } from 'react-redux'
import { useNavigate } from "react-router-dom"
import { firstCharCapitalize } from '../utils/utils';
import _ from 'lodash';
const Path = (props) => {
    const { path, headerData, productosListRouteOrigin } = props
    const navigate = useNavigate()
    const [subtitle, setSubtitle] = useState(props.headerData.subtitle)

    useEffect(() => {
        if (subtitle.toLowerCase().indexOf('promo') > -1) {
            const promoData = _.filter(props.otherCategoriesAll, ['Name', subtitle])[0]
            if (promoData !== undefined) {
                setSubtitle(promoData.Description)
            }
        }
    }, [])


    const handleClickGoPath = (route) => {
        if (route === '') {
            navigate(productosListRouteOrigin)
        } else if (route === 'search') {
            navigate(-1)
        } else {
            navigate(route)
        }
    }

    return (
        <div className="path-container">
            <span className="pointer" onClick={() => handleClickGoPath('/')}>{path}</span>
            {
                headerData.subtitle ?
                    (<span className="pointer" onClick={() => handleClickGoPath('')}> {'/'} {firstCharCapitalize(subtitle)}</span>)
                    :
                    (<span className="pointer" onClick={() => handleClickGoPath('search')}> {'/'} {firstCharCapitalize('Productos')}</span>)
            }
        </div>
    )
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(Path)